// \u2026 is unicode character for horizontal ellipsis - &hellip; in HTML.
export const ellipsis = (str: string, n: number) =>
  str?.length > n ? `${str.substring(0, n - 1)}\u2026` : str;

export const shouldApplyEllipsis = (str: string, n: number) => str?.length > n;
